import { Popup } from 'devextreme-react'
import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Button, Card, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import Breadcrumb from '../../components/common/breadcrumb'
import api from '../../services/api-configuration'

const EmirSilme = () => {
    const [confirmModal, setConfirmModal] = useState(false)
    const [chassisNumber, setChassisNumber] = useState("")


    const deleteLatestManualShipping = async () => {
        document.getElementById('confirmButton').disabled = true
        document.getElementById('cancelButton').disabled = true
        try {
            const response = await api.post(`/deleteLatestManualShipping`, {
                chassis_no: chassisNumber,
                user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))

            })
            if (response.data.success) {
                let message = response.data.message || ""
                toast.success("Manuel sevk emri silindi " + message)
                setChassisNumber("")
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            console.error(error)
            let message = error.response.data.error || ""
            toast.error("Manuel sevk emri silinemedi" + message)
        } finally {
            document.getElementById('confirmButton').disabled = false
            document.getElementById('cancelButton').disabled = false
            setConfirmModal(false)
        }
    }
    return (
        <>
            <Breadcrumb current="Manuel Sevk Emir Silme" />
            <Card className='p-4'>
                <Row>
                    <Col md="6">
                        <FormGroup
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Label for="exampleSelect"><b>Şase Numarası</b>
                                &nbsp;
                            </Label>
                            <Input id="exampleSelect"
                                value={chassisNumber}
                                onChange={(e) => setChassisNumber(e.target.value)}
                            />
                            <Button color="success" style={{ marginLeft: "10px" }}
                                onClick={() => {
                                    if (chassisNumber.length !== 17) {
                                        toast.error("Şase numarası 17 haneli olmalıdır")
                                        return
                                    }
                                    setConfirmModal(true)
                                }}
                            >
                                <i className="fa fa-check" /> &nbsp;
                                OK
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            </Card>

            <Popup title="Manuel Sevk Emri Silme" visible={confirmModal} onHiding={() => setConfirmModal(false)}
                width={400} height={"auto"} showCloseButton={true} dragEnabled={false} closeOnOutsideClick={true}
            >
                <h6>Şaseye ait son manuel sevk emiri silinecektir. Onaylıyor musunuz?</h6>
                <br />
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >

                    <Button color="info" style={{ marginLeft: "10px" }}
                        id='confirmButton'
                        onClick={deleteLatestManualShipping}
                    >
                        Sil
                    </Button>
                    <Button color="danger" style={{ marginLeft: "10px" }}
                        id='cancelButton'
                    >
                        İptal
                    </Button>
                </div>

            </Popup>
        </>
    )
}

export default EmirSilme